
<v-dialog persistent v-model="dialog" content-class="bg-white font-lato p-4" max-width="608"  
  style="border-radius: 0.25rem !important;">
  <div class="mb-6">
    <h4 class="mb-0">Rename Column Label</h4>
  </div>
  <form @submit.prevent="handleSubmit">
    <div class="">
      <div class="d-flex flex-column" style="gap: 16px;">
        <div class="input">
          <label for="label">Label</label>
          <CInput v-model.trim="label" :placeholder="'Label'" :inputType="'text'" :required="true"></CInput>
        </div>
      </div>
    </div>

    <div class="buttons d-flex justify-content-end mt-6">
      <div class="btn btn-outline-primary mr-2" @click="closeModal()">
        Cancel
      </div>
      <button type="submit" class="btn btn-primary">
        Rename
      </button>
    </div>
  </form>
</v-dialog>
